<template>
  <div style="width: 100%; padding-left: 12px; padding-top: 2px;">
    <h5 style="margin-top: 0px !important;">Outbound ➜ Return</h5>
    <v-progress-linear v-if="loading == true" indeterminate color="yellow darken-2" />
    <v-data-table
      v-if="loading == false"
      style="width: 100%;"
      :headers="headers"
      :items="bookingList"
      disable-pagination
      :pagination.sync="pagination"
      :hide-default-footer="true"
      dense
    >
      <template v-slot:item="props">
        <tr>
          <td style="width: 8%;">
            <p>{{props.item.dateString}}</p>
          </td>
          <td style="width: 2%; border-left:4px solid #dddddd;">
            <v-checkbox
              v-if="props.item.outbound != null && (mode == null || (mode == 'alter' && amendTarget == 0 && amendType == 1))"
              class="skinny-box"
              v-model="props.item.outbound.selected"
            ></v-checkbox>
          </td>
          <td style="width: 2%;" v-bind:style="cancelledTextStyle(props.item.outbound)">
            <p v-if="props.item.outbound != null">
              <b>{{props.item.date.format('dddd').substring(0,3)}}</b>
            </p>
          </td>
          <td style="width: 2%;" v-bind:style="cancelledTextStyle(props.item.outbound)">
            <a @click="goToBooking(props.item.outbound.id)">
              <p
                v-if="props.item.outbound != null"
              >{{props.item.outbound.pickup_time.split(" ")[1]}}</p>
            </a>
          </td>
          <td
            class="no-text-overflow"
            style="width: 14%;"
            v-bind:style="cancelledTextStyle(props.item.outbound)"
          >
            <p
              v-if="props.item.outbound != null"
            >{{props.item.outbound.pickup_location.description}}</p>
          </td>
          <td style="width: 3%;" v-bind:style="cancelledTextStyle(props.item.outbound)">
            <p v-if="props.item.outbound != null && props.item.outbound.destinations.length > 1">
              <ViasForBooking :booking="props.item.outbound" />
            </p>
          </td>
          <td
            class="no-text-overflow"
            style="width: 14%;"
            v-bind:style="cancelledTextStyle(props.item.outbound)"
          >
            <p
              v-if="props.item.outbound != null && props.item.outbound.destinations.length > 0"
            >{{props.item.outbound.destinations[0].description}}</p>
          </td>
          <td style="width: 3%;" v-bind:style="cancelledTextStyle(props.item.outbound)">
            <p
              v-if="props.item.outbound != null"
            >{{(props.item.outbound.final_cost / 100).toFixed(2)}}</p>
          </td>
          <td style="width: 5%;">
            <p v-if="props.item.outbound != null && props.item.outbound.preassigned_driver != null">
              <b>{{props.item.outbound.preassigned_driver.driver.callsign }}</b>
              {{props.item.outbound.preassigned_driver.driver.name}}
            </p>
          </td>
          <td style="width: 2%; border-left:4px solid #dddddd;">
            <v-checkbox
              v-if="props.item.inbound != null && (mode == null || (mode == 'alter' && amendTarget == 1 && amendType == 1))"
              class="skinny-box"
              v-model="props.item.inbound.selected"
            ></v-checkbox>
          </td>
          <td style="width: 2%;" v-bind:style="cancelledTextStyle(props.item.inbound)">
            <p v-if="props.item.inbound != null">
              <b>{{props.item.date.format('dddd').substring(0,3)}}</b>
            </p>
          </td>
          <td style="width: 3%;" v-bind:style="cancelledTextStyle(props.item.inbound)">
            <a @click="goToBooking(props.item.inbound.id)">
              <p v-if="props.item.inbound != null">{{props.item.inbound.pickup_time.split(" ")[1]}}</p>
            </a>
          </td>
          <td
            class="no-text-overflow"
            style="width: 14%;"
            v-bind:style="cancelledTextStyle(props.item.inbound)"
          >
            <p v-if="props.item.inbound != null">{{props.item.inbound.pickup_location.description}}</p>
          </td>
          <td style="width: 3%;" v-bind:style="cancelledTextStyle(props.item.inbound)">
            <p v-if="props.item.inbound != null && props.item.inbound.destinations.length > 1">
              <ViasForBooking :booking="props.item.inbound" />
            </p>
          </td>
          <td
            class="no-text-overflow"
            style="width: 14%;"
            v-bind:style="cancelledTextStyle(props.item.inbound)"
          >
            <p
              v-if="props.item.inbound != null && props.item.inbound.destinations.length > 0"
            >{{props.item.inbound.destinations[0].description}}</p>
          </td>
          <td style="width: 3%;" v-bind:style="cancelledTextStyle(props.item.inbound)">
            <p
              v-if="props.item.inbound != null"
            >{{(props.item.inbound.final_cost / 100).toFixed(2)}}</p>
          </td>
          <td style="width: 5%;">
            <span
              v-if="props.item.inbound != null && props.item.inbound.preassigned_driver != null"
            >
              <b>{{props.item.inbound.preassigned_driver.driver.callsign}}</b>
              <p>{{props.item.inbound.preassigned_driver.driver.name}}</p>
            </span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import qs from "qs";
import axios from "axios";
import { setTimeout } from "timers";
axios.defaults.withCredentials = true;

import moment from "moment";

import ViasForBooking from "@/components/overwatch/ViasForBooking.vue";

export default {
  name: "repeat_trip_list",
  components: {
    ViasForBooking,
  },
  props: {
    repeatService: Object,
    loading: Boolean,
    mode: String,
    amendTarget: Number,
    amendType: Number,
    paginationProp: Object
  },
  mounted: async function () {},
  data: function () {
    return {
      pagination: this.paginationProp,
      headers: [
        {
          text: "Date",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: "",
          align: "left",
          sortable: false,
          value: "selectA",
        },
        {
          text: "Day",
          align: "left",
          sortable: false,
          value: "user",
        },
        {
          text: "Time",
          align: "left",
          sortable: false,
          value: "user",
        },
        {
          text: "Pickup",
          align: "left",
          sortable: false,
          value: "user",
        },
        {
          text: "Vias",
          align: "left",
          sortable: false,
          value: "user",
        },
        {
          text: "Destinations",
          align: "left",
          sortable: false,
          value: "user",
        },
        {
          text: "Final Cost",
          align: "left",
          sortable: false,
          value: "user",
        },
        {
          text: "Driver",
          align: "left",
          sortable: false,
          value: "user",
        },
        {
          text: "",
          align: "left",
          sortable: false,
          value: "selectB",
        },
        {
          text: "Day",
          align: "left",
          sortable: false,
          value: "user",
        },
        {
          text: "Time",
          align: "left",
          sortable: false,
          value: "user",
        },
        {
          text: "Pickup",
          align: "left",
          sortable: false,
          value: "user",
        },
        {
          text: "Vias",
          align: "left",
          sortable: false,
          value: "user",
        },
        {
          text: "Destinations",
          align: "left",
          sortable: false,
          value: "user",
        },
        {
          text: "Final Cost",
          align: "left",
          sortable: false,
          value: "user",
        },
        {
          text: "Driver",
          align: "left",
          sortable: false,
          value: "user",
        },
      ],
    };
  },
  computed: {
    spanOfDatesForRepeatService: function () {
      var tripABookings = this.repeatService.repeatServiceModel.trip_a
        .repeat_booking_entries;

      if (tripABookings.length > 0) {
        var tripsStart = moment(
          tripABookings[0].booking.pickup_time,
          "DD/MM/YYYY HH:mm"
        );
        var tripsEnd = moment(
          tripABookings[tripABookings.length - 1].booking.pickup_time,
          "DD/MM/YYYY HH:mm"
        );
      }

      if (this.repeatService.repeatServiceModel.trip_b != null) {
        var tripBBookings = this.repeatService.repeatServiceModel.trip_b
          .repeat_booking_entries;

        if (tripBBookings.length > 0) {
          var tripsBStart = moment(
            tripBBookings[0].booking.pickup_time,
            "DD/MM/YYYY HH:mm"
          );

          var tripsBEnd = moment(
            tripBBookings[tripBBookings.length - 1].booking.pickup_time,
            "DD/MM/YYYY HH:mm"
          );

          if (tripsStart == null || tripsStart.isAfter(tripsBStart)) {
            tripsStart = tripsBStart;
          }

          if (tripsEnd == null || tripsEnd.isBefore(tripsBEnd)) {
            tripsEnd = tripsBEnd;
          }
        }
      }

      return { start_date: tripsStart, end_date: tripsEnd };
    },
    datesBetweenSpan: function () {
      var bookingDateSpan = this.spanOfDatesForRepeatService;

      var currDate = moment(bookingDateSpan.start_date).startOf("day");
      var lastDate = moment(bookingDateSpan.end_date).startOf("day");

      var dates = [];

      dates.push(moment(currDate.toDate()));

      while (currDate.add(1, "days").diff(lastDate) < 2) {
        dates.push(moment(currDate.toDate()));
      }

      return dates;
    },
    bookingList: function () {
      var dateList = this.datesBetweenSpan;

      var tripABookings = this.repeatService.repeatServiceModel.trip_a
        .repeat_booking_entries;

      var tripADateBooking = this.tripListToMap(tripABookings);

      var tripBBookings = [];
      var tripBDateBooking = {};

      if (this.repeatService.repeatServiceModel.trip_b != null) {
        var tripBBookings = this.repeatService.repeatServiceModel.trip_b
          .repeat_booking_entries;

        tripBDateBooking = this.tripListToMap(tripBBookings);
      }

      var outboundReturns = [];

      for (var i = 0; i < dateList.length; i++) {
        var dateString = dateList[i].format("YYYY-MM-DD");

        var outboundReturn = {
          date: dateList[i],
          dateString: dateString,
          outbound: tripADateBooking[dateString],
          inbound: tripBDateBooking[dateString],
        };

        if (outboundReturn.outbound != null || outboundReturn.inbound != null) {
          outboundReturns.push(outboundReturn);
        }
      }

      return outboundReturns;
    },
  },
  methods: {
    goToBooking: function (bookingID) {
      let routeData = this.$router.resolve({
        path: "/bookings",
        query: { bookingID: bookingID },
      });
      window.open(routeData.href, "_blank");
    },
    cancelledTextStyle: function (booking) {
      if (booking == null) {
        return {};
      }

      if (booking.state == "cancelled") {
        return {
          "text-decoration": "line-through",
        };
      } else if (booking.state == "completed") {
        return {
          opacity: "0.5",
        };
      }

      return {};
    },
    tripListToMap: function (tripList) {
      var dateTripMap = {};
      for (var i = 0; i < tripList.length; i++) {
        var booking = tripList[i].booking;

        var dateString = moment(booking.pickup_time, "DD/MM/YYYY HH:mm")
          .toDate()
          .toISOString()
          .substr(0, 10);

        // console.log(dateString, booking.pickup_time);

        dateTripMap[dateString] = booking;
      }

      return dateTripMap;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.skinny-box {
  margin: 0px !important;
  padding: 0px !important;
  height: 16px !important;
  width: 16px !important;
}

.no-text-overflow {
  // overflow: hidden;
  // white-space: nowrap;
  // text-overflow: ellipsis;
  word-break: break-all;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 3px !important;
}

thead th:not(:first-child) {
  padding: 0 4px;
}

.v-data-table td {
  font-size: 14px;
  height: 19px !important;
}

.v-data-table td {
  padding: 0 0px !important;
}

.v-data-table th {
  padding: 0 0px !important;
}

.v-data-table th {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 12px;
  height: 24px !important;
}
</style>
